export default __webpack_public_path__ + "static/media/Success_Green.1d93e049.svg";